/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const defaultProps = {
  expanded: true,
  onChange: () => {},
};

const propTypes = {
  expanded: React.PropTypes.bool,
  onChange: React.PropTypes.func,
  intl: React.PropTypes.any.isRequired,
};

class CollapseToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded,
    };
    this.intlMsg = new IntlMsg(props.intl, 'lora.coms.collapsetoggle');
  }

  componentWillReceiveProps(nextProps) {
    const { expanded } = nextProps;
    if (expanded !== this.props.expanded) {
      this.setState({ expanded });
    }
  }

  render() {
    const { onChange } = this.props;
    const { expanded = true } = this.state;

    let tooltip;
    let icon;
    if (expanded) {
      icon = <span className="glyphicons glyphicons-expand" />;
      tooltip = (
        <Tooltip id="tooltip-collapseTogge-collapsed">
          {this.intlMsg.msg('collapse')}
        </Tooltip>
      );
    } else {
      icon = <span className="glyphicons glyphicons-collapse text-warning" />;
      tooltip = (
        <Tooltip id="tooltip-collapseTogge-expanded">
          {this.intlMsg.msg('expand')}
        </Tooltip>
      );
    }

    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <button
          onClick={() => onChange(!expanded)}
          className={`icon ${styles.btnLink}`}
        >
          {icon}
        </button>
      </OverlayTrigger>
    );
  }
}

CollapseToggle.propTypes = propTypes;
CollapseToggle.defaultProps = defaultProps;

export default injectIntl(CollapseToggle);




// WEBPACK FOOTER //
// ./src/components/CollapseToggle/index.jsx